import { createApp, ref, readonly, reactive, computed} from 'vue';
import UserNewView from '../vue/view/UserNewView.vue'
import RegistrationApp from '../view/components/registration/RegistrationApp.vue';
import { UserRegistrationPresenter, GroupRegistrationPresenter } from '../presenter/registration';
import { registrationViewModelInjectKey, userRegistrationPresenterInjectKey, groupRegistrationPresenterInjectKey, userRegistrationViewModelInjectKey, groupRegistrationViewModelInjectKey, userImageURLInjectKey } from '../provider/provider';
import { i18n } from '../i18n';

const USER_NEW_VIEW = {
  EDIT: "#user-new-view",
}

function mountFormComponent(component, mountPoint, props, imageURL) {
  const app = createApp(component, props);
  app.use(i18n);
  app.provide(userImageURLInjectKey, ref(imageURL));
  window[mountPoint] = app.mount(mountPoint);
}

function mountUserNewView(props) {
  mountFormComponent(UserNewView, USER_NEW_VIEW.EDIT, {
    thisUser: props.thisUser,
    user: props.user,
    activeUserId: props.user.ID,
    changePasswordAndLogin: false,
    enabledSmartHR: props.enabledSmartHR,
    profilePhotoEnabled: props.profilePhotoEnabled,
    branchId: props.branchId,
    hasSmartHRAttendenceToken: props.hasSmartHRAttendenceToken,
  }, props.imageURL,);
}

function mountRegistrationApp(props) {
  const app = createApp(RegistrationApp);
  const viewModel = initRegistrationViewModel(props);
  const userViewModel = initUserRegistrationViewModel(props);
  const groupViewModel = initGroupRegistrationViewModel(props);

  const userPresenter  = new UserRegistrationPresenter(viewModel.value, userViewModel.value);
  const groupPresenter = new GroupRegistrationPresenter(viewModel.value, userViewModel.value, groupViewModel.value);

  app.provide(registrationViewModelInjectKey, readonly(viewModel));
  app.provide(userRegistrationViewModelInjectKey, readonly(userViewModel));
  app.provide(groupRegistrationViewModelInjectKey, readonly(groupViewModel));

  app.provide(userRegistrationPresenterInjectKey,  userPresenter);
  app.provide(groupRegistrationPresenterInjectKey, groupPresenter);
  window["#registration-app"] = app.mount("#registration-app");
}

function initRegistrationViewModel(props) {
  return ref({
    branchId: props.thisUser.comID || 0,
    branchCategories: props.branchCategories || [],
    referrers: props.referrers || [],
    isOwner: props.thisUser.isOwner,
    needHubspot: props.needHubspot,
    step: 1,
    isLoading: false,
    actionURL: props.actionURL,
    selectedFeatures: [0],
  });
}

function initUserRegistrationViewModel(props){
  return ref({
    form: {
      id: props.thisUser.id || 0,
      name: '',
      furigana: '',
      phone: props.thisUser.phone || '',
      email: '',
    },
    errors: { name: false, furigana: false, phone: false, email: false },
  });
}

function initGroupRegistrationViewModel(props) {
  return ref({
    form: {
      name: '',
      address: '',
      category: null,
      numOfExpectedUsers: null,
      numOfExpectedBranches: null,
      referrer: null,
    },
    errors: { name: false, address: false, category: false, numOfExpectedUsers: false, numOfExpectedBranches: false, referrer: false },
  });
}

export function initPage(props) {
  if (props.user) {
    mountUserNewView(props);
  } else {
    mountRegistrationApp(props);
  }
}
